async function fetchProductByHandle(handle) {
  try {
    const response = await fetch(`/products/${handle}.js`);
    if (!response.ok) throw new Error(`Failed to fetch product ${handle}`);
    return await response.json();
  } catch (err) {
    console.error(err);
    return null;
  }
}

function formatMoney(cents) {
  if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, Shopify.money_format);
  } else {
    return '€' + (cents / 100).toFixed(2);
  }
}

async function renderFrequentlyBoughtTogether() {
  const bundleMetafield = document.querySelector('[data-bundle-products]');
  const currentProductHandle = document.querySelector('meta[property="og:url"]').content.split('/products/')[1].split('?')[0];
  if (!bundleMetafield || !currentProductHandle) return;

  const productHandles = [currentProductHandle, ...bundleMetafield.dataset.bundleProducts.split(',')];
  const container = document.querySelector('#frequently-bought-together');
  if (!container) return;

  let subtotal = 0;
  const products = [];

  const title = document.createElement('h3');
  title.textContent = 'Rotina Recomendada';
  container.appendChild(title);

  const productsWrapper = document.createElement('div');
  productsWrapper.className = 'fbt-products-wrapper';
  container.appendChild(productsWrapper);

  for (let i = 0; i < productHandles.length; i++) {
    const handle = productHandles[i].trim();
    if (!handle) continue;
    const product = await fetchProductByHandle(handle);
    if (product) {
      const isCurrentProduct = i === 0;
      const checkboxAttributes = isCurrentProduct ? 'checked disabled' : 'checked';
      const thumbnailSrc = product.featured_image.includes('?')
        ? `${product.featured_image}&width=70`
        : `${product.featured_image}?width=70`;
      const productHTML = `
        <div class="fbt-product">
          <label class="fbt-product-box">
            <input 
              type="checkbox" 
              class="fbt-checkbox" 
              data-id="${product.variants[0].id}" 
              data-price="${product.price}" 
              ${checkboxAttributes}>
            <a href="${product.url}" class="fbt-thumbnail">
              <img src="${thumbnailSrc}" alt="${product.title}" width="58" height="58" />
            </a>
            <div class="fbt-details">
              <a href="${product.url}" class="fbt-title">${product.title}</a>
              <p class="fbt-price">${formatMoney(product.price)}</p>
            </div>
          </label>
        </div>
      `;
      productsWrapper.insertAdjacentHTML('beforeend', productHTML);
      products.push(product);
    }
  }

  const addToCartButton = document.createElement('button');
  addToCartButton.textContent = 'Adicionar seleção ao carrinho';
  addToCartButton.className = 'fbt-add-to-cart';

  const subtotalContainer = document.createElement('div');
  subtotalContainer.id = 'fbt-subtotal';
  subtotalContainer.className = 'fbt-subtotal';

  container.appendChild(subtotalContainer);
  container.appendChild(addToCartButton);

  container.insertBefore(subtotalContainer, addToCartButton);

  addToCartButton.addEventListener('click', async () => {
    const selectedVariants = Array.from(document.querySelectorAll('input.fbt-checkbox:checked')).map(cb => ({
      id: cb.dataset.id,
      quantity: 1
    }));

    if (selectedVariants.length === 0) return;

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: selectedVariants
        })
      });
      window.location.href = '/cart';
    } catch (err) {
      console.error('Error adding to cart:', err);
    }
  });

  container.addEventListener('change', (e) => {
    if (e.target.classList.contains('fbt-checkbox')) {
      updateSubtotal();
    }
  });

  const updateSubtotal = () => {
    let newSubtotal = 0;
    document.querySelectorAll('input.fbt-checkbox:checked').forEach(cb => {
      newSubtotal += parseInt(cb.dataset.price);
    });
    subtotalContainer.innerHTML = `Subtotal: <strong>${formatMoney(newSubtotal)}</strong>`;
  };

  updateSubtotal();
}

document.addEventListener('DOMContentLoaded', renderFrequentlyBoughtTogether);